import { Link } from "react-router-dom";
import PageShell from "@/components/layout/PageShell";

export default function NotFound() {
  return (
    <PageShell>
      <section className="min-h-[70vh] bg-white flex items-center">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10">
          <div className="overline mb-6">404 · Page not found</div>
          <h1 className="font-serif text-[14vw] md:text-[10vw] leading-none tracking-[-0.02em] text-[#0B2545]">
            Off route.
          </h1>
          <p className="mt-8 text-[#5B6472] max-w-lg text-lg leading-relaxed">
            The page you're looking for doesn't exist. Let's get you back on the road.
          </p>
          <Link to="/" className="btn-primary mt-8" data-testid="nf-home">Back to home</Link>
        </div>
      </section>
    </PageShell>
  );
}
